/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_Data_NoteInputs */

const en_pol_data_note = /** @type {(inputs: Pol_Data_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This table is data we update when a provider changes its rules, not legal advice. Cell notes are in the language of the original source.`)
};

const id_pol_data_note = /** @type {(inputs: Pol_Data_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabel ini data yang kami perbarui bila penyedia mengubah aturannya, bukan nasihat hukum. Catatan tiap sel memakai bahasa sumber aslinya.`)
};

/**
* | output |
* | --- |
* | "This table is data we update when a provider changes its rules, not legal advice. Cell notes are in the language of the original source." |
*
* @param {Pol_Data_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_data_note = /** @type {((inputs?: Pol_Data_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_Data_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_data_note(inputs)
	return en_pol_data_note(inputs)
});